import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
// import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
// import Zoom from "react-medium-image-zoom";
// import Switch from "@mui/material/Switch";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import SortIcon from "@mui/icons-material/Sort";
// import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import AmenitiesModal from "./AmenitiesModal";
// import AllAmenities from "./AllAmenities";

import { makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";

// End

// const label = { inputProps: { "aria-label": "Size switch demo" } };

function BookAmenities() {
  const navigate = useNavigate();

  // For memu
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open2 = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose2 = () => {
  //   setAnchorEl(null);
  // };
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  const [amenitiesList, setAmenitiesList] = React.useState([]);

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    AmenitiesListing();
  }, [open]);
  // End

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  async function AmenitiesListing() {
    let bodyFormData = {
      searchq: "",
      pageNo: "",
      count: "",
      status: true,
    };

    makePostRequest("amenities/alllisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log(response.data.data.rowCount);
          const data = response.data.data.rows;
          console.log(data);
          setAmenitiesList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  function bookAmenity(amenityObj) {
    console.log(amenityObj);
    localStorage.setItem("amenityObj", JSON.stringify(amenityObj));
    navigate("/BookAmenitiesDetailsNew");
  }

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid
          container
          spacing={3}
          className="mainHeadingLine AmenitiesOuterMain"
        >
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Book Amenities</h1>
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="">
                <div className="bookAmiListNewInner">
                  <div className="bookAmiOut">
                    {amenitiesList.map((option) => (
                      <div
                        className="bookAmiImOut"
                        onClick={() => bookAmenity(option)}
                      >
                        <div className="bookAmiImg">
                          <img src={option.lstAmenityImages[0]} />
                        </div>
                        <p>{option.amenity_name}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Amenity</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AmenitiesModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default BookAmenities;
